<div class="content">
  <div>{{ "publist.download" | translate }} {{ pub.verbatimText }} {{ displayedRevision }}</div>
  <div>{{ "publist.download.advices" | translate }}</div>
</div>
<o-card-pub-container [lastRev]="pub" [isDownloading]="true"></o-card-pub-container>
